import { useNavigate } from 'react-router-dom';
import styles from './documents-download-toaster.module.scss';
const DownloadSuccessToaster = () => {
	const navigate = useNavigate();

	const handleOnClick = () => {
		navigate('/mydownloads');
	};

	return (
		<div className={styles.successMessage}>
			Files downloaded to the “My Downloads” page.
			<a
				className={styles.viewFileLink}
				onClick={handleOnClick}>
				{' '}
				<span className={styles.viewFileText}>View Files</span>
			</a>
		</div>
	);
};

export default DownloadSuccessToaster;
